module.exports = __webpack_public_path__ + "static/vuejs-c1d0c1520d62a811f9de297eecc08235.png";